/* eslint-disable import/no-cycle */

import type { NormalizedCacheObject } from "@apollo/client";
import type { ItemType } from "@shared/graphql.types";

export function isEmpty(data: NormalizedCacheObject | null): boolean {
  return data === null || Array.from(Object.keys(data)).length === 0;
}

//-----------------------------------------------------------------------------------------

export const calculateBasketCount = (basket: ItemType[]): number => {
  if (!basket) return 0;

  return basket.reduce((count, item) => {
    return item?.variant?.availability?.status === "instock" ||
      item?.variant === null
      ? count + item.quantity
      : count;
  }, 0);
};
